/* LimmiGlow — C³ System buy box.
   One-time: adds the bundle product (or the three singles). Subscribe & Save: adds Origin, Vitality and
   Performance as three lines, each on its own C³ selling plan, in one checkout. Prices come from Shopify. */
(function () {
  if (customElements.get('c3-buy-box')) return;

  class C3BuyBox extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      this.moneyFormat = this.data.money_format || '${{amount}}';
      this.trimZeros = this.data.trim_zeros !== false;
      this.mode = this.data.default_mode === 'one_time' ? 'one_time' : 'subscribe';
      this.selection = {};
      this.data.products.forEach((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        this.selection[p.key] = v ? v.id : null;
      });
      this.button = this.querySelector('[data-c3-add]');
      this.error = this.querySelector('[data-c3-error]');
      this.sticky = this.querySelector('[data-c3-sticky]');
      this.stickyBtn = this.sticky ? this.sticky.querySelector('[data-c3-sticky-add]') : null;
      this.stickySelect = this.sticky ? this.sticky.querySelector('[data-c3-sticky-select]') : null;
      this.bindModes();
      this.bindPickers();
      this.bindSticky();
      if (!this.canSubscribe()) this.mode = 'one_time';
      this.render();
      if (this.button) this.button.addEventListener('click', () => this.add());
      if (this.stickyBtn) this.stickyBtn.addEventListener('click', () => this.add());
    }
    disconnectedCallback() { if (this.sticky && this.sticky.parentNode === document.body) this.sticky.remove(); }

    /* ---------- helpers */
    money(cents) {
      const amount = (cents / 100).toFixed(2);
      let out = this.moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toLocaleString('de-DE'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US'))
        .replace(/\{\{\s*amount\s*\}\}/, Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      out = out.replace(/<[^>]*>/g, '');
      if (this.trimZeros) out = out.replace(/([.,])00(?!\d)/, '');
      return out;
    }
    product(key) { return this.data.products.find((p) => p.key === key); }
    variant(key) {
      const p = this.product(key);
      return p ? p.variants.find((v) => v.id === this.selection[key]) : null;
    }
    singlesTotal(field) {
      return this.data.products.reduce((sum, p) => {
        const v = this.variant(p.key);
        return sum + (v && v[field] != null ? v[field] : 0);
      }, 0);
    }
    canSubscribe() {
      return this.data.products.length === 3 && this.data.products.every((p) => {
        const v = this.variant(p.key);
        return v && v.plan_price != null;
      });
    }
    bundleVariant() {
      const b = this.data.bundle;
      if (!b || !b.variants.length) return null;
      if (b.variants.length === 1) return b.variants[0];
      // Match the bundle variant to the chosen options of the singles (e.g. Vitality flavor).
      const chosen = this.data.products.map((p) => this.variant(p.key)).filter((v) => v && v.title !== 'Default Title').map((v) => v.title.toLowerCase());
      const match = b.variants.find((bv) => chosen.every((t) => bv.title.toLowerCase().includes(t)));
      return match || b.variants.find((v) => v.available) || b.variants[0];
    }
    oneTimePrice() {
      if (this.data.one_time_source === 'bundle') {
        const bv = this.bundleVariant();
        return bv ? bv.price : this.singlesTotal('price');
      }
      return this.singlesTotal('price');
    }
    oneTimeAvailable() {
      if (this.data.one_time_source === 'bundle') { const bv = this.bundleVariant(); return !!(bv && bv.available); }
      return this.data.products.every((p) => { const v = this.variant(p.key); return v && v.available; });
    }
    subscribeAvailable() {
      return this.canSubscribe() && this.data.products.every((p) => { const v = this.variant(p.key); return v && v.available; });
    }

    /* ---------- UI wiring */
    bindModes() {
      this.querySelectorAll('input[name="c3-mode"]').forEach((input) => {
        input.addEventListener('change', () => { this.mode = input.value; this.render(); });
      });
    }
    bindPickers() {
      this.querySelectorAll('[data-c3-pick]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.selection[btn.dataset.c3Pick] = Number(btn.dataset.variant);
          this.render();
          this.dispatchEvent(new CustomEvent('c3:variant-change', { bubbles: true, detail: { product: btn.dataset.c3Pick, variantId: Number(btn.dataset.variant) } }));
        });
      });
    }
    bindSticky() {
      const sticky = this.sticky;
      if (!sticky || !this.button || !('IntersectionObserver' in window)) return;
      // position: fixed must not sit inside an animated/transformed ancestor
      document.body.appendChild(sticky);
      const io = new IntersectionObserver((entries) => {
        const visible = entries.some((e) => e.isIntersecting);
        const above = entries.some((e) => e.boundingClientRect.top < 0);
        sticky.classList.toggle('is-visible', !visible && above);
      }, { threshold: 0 });
      io.observe(this.button);
      // dropdown: sticky select → update mode and re-render (main radios follow via render)
      if (this.stickySelect) {
        this.stickySelect.addEventListener('change', () => {
          this.mode = this.stickySelect.value;
          this.render();
        });
      }
      // anchor: smooth-scroll to the buy box
      const anchor = sticky.querySelector('[data-c3-sticky-anchor]');
      if (anchor) {
        anchor.addEventListener('click', (e) => {
          const target = document.querySelector(anchor.getAttribute('href'));
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      }
    }

    render() {
      const oneTime = this.oneTimePrice();
      const separately = this.singlesTotal('price');
      const subscribe = this.canSubscribe() ? this.singlesTotal('plan_price') : null;
      const oneTimeOk = this.oneTimeAvailable();
      const subOk = this.subscribeAvailable();
      if (this.mode === 'subscribe' && !subOk && oneTimeOk) this.mode = 'one_time';

      // mode radios
      this.querySelectorAll('input[name="c3-mode"]').forEach((input) => {
        input.checked = input.value === this.mode;
        const row = input.closest('[data-c3-option]');
        if (row) {
          row.classList.toggle('is-selected', input.checked);
          const unavailable = input.value === 'subscribe' ? !subOk : !oneTimeOk;
          row.classList.toggle('is-unavailable', unavailable);
          input.disabled = unavailable;
        }
      });
      // prices
      this.setText('[data-c3-price-one-time]', this.money(oneTime));
      this.setText('[data-c3-price-subscribe]', subscribe != null ? this.money(subscribe) : '');
      const saveOne = separately - oneTime;
      this.toggle('[data-c3-separately]', saveOne > 0);
      this.setText('[data-c3-price-separately]', this.money(separately));
      this.setText('[data-c3-save-one-time]', saveOne > 0 ? this.money(saveOne) : '');
      const saveSub = subscribe != null ? oneTime - subscribe : 0;
      this.toggle('[data-c3-compare-subscribe]', saveSub > 0);
      this.setText('[data-c3-price-subscribe-compare]', this.money(oneTime));
      this.setText('[data-c3-save-subscribe]', saveSub > 0 ? this.money(saveSub) : '');
      // replenishment rows
      this.data.products.forEach((p) => {
        const v = this.variant(p.key);
        this.setText(`[data-c3-renewal="${p.key}"]`, v && v.plan_price != null ? this.money(v.plan_price) : '');
        this.setText(`[data-c3-selected="${p.key}"]`, v ? v.title : '');
      });
      this.toggle('[data-c3-replenishment]', this.mode === 'subscribe' && subscribe != null);
      // pickers
      this.querySelectorAll('[data-c3-pick]').forEach((btn) => {
        const on = Number(btn.dataset.variant) === this.selection[btn.dataset.c3Pick];
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // button + sticky
      const price = this.mode === 'subscribe' ? subscribe : oneTime;
      const available = this.mode === 'subscribe' ? subOk : oneTimeOk;
      const label = available ? (this.data.button_label || 'Add to cart') : (this.data.sold_out_label || 'Sold out');
      [this.button, this.stickyBtn].forEach((b) => {
        if (!b) return;
        b.disabled = !available;
        this.setText('[data-c3-btn-label]', label, b);
        this.setText('[data-c3-btn-price]', price != null ? this.money(price) : '', b);
      });
      if (this.sticky) {
        this.setText('[data-c3-sticky-price]', price != null ? this.money(price) : '', this.sticky);
      }
      if (this.stickySelect) {
        // option labels carry live prices
        Array.prototype.forEach.call(this.stickySelect.options, (opt) => {
          if (opt.value === 'subscribe') {
            const lbl = this.data.subscribe_label || 'Subscribe & Save';
            opt.textContent = subscribe != null ? lbl + ' \u00b7 ' + this.money(subscribe) : lbl;
            opt.disabled = !subOk;
            opt.hidden = subscribe == null;
          } else {
            const lbl = this.data.one_time_label || 'One-time purchase';
            opt.textContent = lbl + ' \u00b7 ' + this.money(oneTime);
            opt.disabled = !oneTimeOk;
          }
        });
        // keep dropdown in sync with current mode
        this.stickySelect.value = this.mode;
      }
    }
    setText(sel, text, root) { (root || this).querySelectorAll(sel).forEach((el) => { el.textContent = text; }); }
    toggle(sel, show) { this.querySelectorAll(sel).forEach((el) => { el.hidden = !show; }); }

    /* ---------- cart */
    items() {
      if (this.mode === 'subscribe') {
        return this.data.products.map((p) => ({ id: this.selection[p.key], quantity: 1, selling_plan: p.plan_id }));
      }
      if (this.data.one_time_source === 'bundle') {
        const bv = this.bundleVariant();
        if (bv) return [{ id: bv.id, quantity: 1 }];
      }
      return this.data.products.map((p) => ({ id: this.selection[p.key], quantity: 1 }));
    }
    setError(msg) {
      if (!this.error) return;
      this.error.textContent = msg || '';
      this.error.hidden = !msg;
    }
    add() {
      if (!this.button || this.button.classList.contains('loading') || this.button.disabled) return;
      this.setError(null);
      this.button.classList.add('loading');
      this.button.setAttribute('aria-busy', 'true');
      const items = this.items();
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'] }),
      })
        .then((res) => res.json())
        .then((state) => {
          if (state.status) { this.setError(state.description || state.message || this.data.error_label); return; }
          this.dispatchEvent(new CustomEvent('c3:added', { bubbles: true, detail: { mode: this.mode, items, response: state } }));
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
            drawer.renderContents(state, true);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => this.setError(this.data.error_label || 'Something went wrong. Please try again.'))
        .finally(() => { this.button.classList.remove('loading'); this.button.removeAttribute('aria-busy'); });
    }
  }
  customElements.define('c3-buy-box', C3BuyBox);
})();